import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RejectPostListLayer from "../../components/Post/RejectPostListLayer";


const RejectedPostList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Rejected Post" />

        {/* UsersListLayer */}
        <RejectPostListLayer />

      </MasterLayout>

    </>
  );
};

export default RejectedPostList;
